import { Outlet } from "react-router-dom";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import WhatsAppFloat from "@/components/sections/WhatsAppFloat";
import CartFloat from "@/components/sections/CartFloat";
import VehicleSelector from "@/components/sections/VehicleSelector";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#050505] text-white overflow-x-hidden flex flex-col" data-testid="site-layout">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CartFloat />
      <VehicleSelector />
    </div>
  );
}
